import React from "react";
import {
  Box,
  Grid,
  Typography,
  Paper,
  Container,
  Button,
  Stack,
  Divider,
  Card,
  CardContent,
  Link
} from "@mui/material";
import imgUrl from "../../assets/images/imgUrl";


const conclusions = [
  {
    // title: "Gratitude",
    description: ` Course access — online and hybrid delivery.`,
    // image: valueGratitude,
  },
  {
    // title: "Forgiveness",
    description: `Eligibility —  open to all, free for Youth under 18.`,
    // image: valueForgiving,
  },
  {
    // title: "Love",
    description: `Goal — cultivate values for inner and Global Peace.`,
    // image: valueLove,
  },
   {
    // title: "Love",
    description: ` Global reach — <br></br> across every continent.`,
    // image: valueLove,
  }
];


const onlineTest = [
  {
    text: (
      <>
        Embed the 7 Human <br></br> Values in daily life.
      </>
    ),
    colorClass: "gradient-blue",
  },
  {
    text: (
      <>
        Improve emotional <br></br> intelligence and resilience.
      </>
    ),
    colorClass: "gradient-yellow",
  },
   {
    text: (
      <>
      Strengthen leadership <br></br> and conflict resolution skills.
      </>
    ),
    colorClass: "gradient-blue",
  },
  {
    text: (
      <>
       Promote equality, empathy <br></br> and collaboration.
      </>
    ),
    colorClass: "gradient-yellow",
  },
    {
    text: (
      <>
       Foster community <br></br> action for Peace.
      </>
    ),
    colorClass: "gradient-blue",
  },
   {
    text: (
      <>
       Expand intercultural <br></br> understanding.
      </>
    ),
    colorClass: "gradient-yellow",
  },
   {
    text: (
      <>
       Inspire lifelong commitment <br></br> to Justice, Love & Peace.
      </>
    ),
    colorClass: "gradient-blue",
  },
];

const coreValues = [
  {
    // title: "Gratitude",
    description: `Inner Peace Course - Live`,
    // image: valueGratitude,
  },
  {
    // title: "Forgiveness",
    description: `Women in Peace Course - Coming Soon`,
    // image: valueForgiving,
  },
  {
    // title: "Love",
    description: `Peace Leadership Course - Coming Soon`,
    // image: valueLove,
  }
];
const courseBenefits = [
  {
    // title: "Gratitude",
    description: ` Certificate of recognition.`,
    // image: valueGratitude,
  },
  {
    // title: "Forgiveness",
    description: ` Flexible online modules.`,
    // image: valueForgiving,
  },
  {
    // title: "Love",
    description: `Expert‑led sessions.`,
    // image: valueLove,
  },
   {
    // title: "Love",
    description: `Downloadable resources.`,
    // image: valueLove,
  },
    {
    // title: "Love",
    description: ` Real‑life application tasks.`,
    // image: valueLove,
  },
   {
    // title: "Love",
    description: `Peer‑to‑peer networking.`,
    // image: valueLove,
  },
     {
    // title: "Love",
    description: `Discussion forums.`,
    // image: valueLove,
  },
   {
    // title: "Love",
    description: `Live Q&A events.`,
    // image: valueLove,
  },
  {
    // title: "Love",
    description: `Project showcase opportunities.`,
    // image: valueLove,
  },
   {
    // title: "Love",
    description: <>
            Pathways to become an I Am Peacekeeper Ambassador.


    </>,
    // image: valueLove,
  },
   {
    // title: "Love",
    description: <>
           Listing on official I Am Peacekeeper websites.


    </>,
    // image: valueLove,
  },
   {
    // title: "Love",
    description: <>
          Access to alumni community and advanced courses.

    </>,
    // image: valueLove,
  },

];

// const courseBenefits = [
//   {
//     text: (
//       <>
//         Certificate of recognition.
//       </>
//     ),
//     colorClass: "gradient-blue",
//   },
//   {
//     text: (
//       <>
//         Flexible online modules.
//       </>
//     ),
//     colorClass: "gradient-yellow",
//   },
//    {
//     text: (
//       <>
//       Expert‑led sessions.
//       </>
//     ),
//     colorClass: "gradient-blue",
//   },
//   {
//     text: (
//       <>
//        Downloadable resources.
//       </>
//     ),
//     colorClass: "gradient-yellow",
//   },
//    {
//     text: (
//       <>
//        Real‑life application tasks.
//       </>
//     ),
//     colorClass: "gradient-blue",
//   },
//    {
//     text: (
//       <>
//        Peer‑to‑peer networking.
//       </>
//     ),
//     colorClass: "gradient-yellow",
//   },
//     {
//     text: (
//       <>
//       Discussion forums.
//       </>
//     ),
//     colorClass: "gradient-blue",
//   },
//    {
//     text: (
//       <>
//       Live Q&A events.
//       </>
//     ),
//     colorClass: "gradient-yellow",
//   },
//   {
//     text: (
//       <>
//       Project showcase opportunities.
//       </>
//     ),
//     colorClass: "gradient-blue",
//   },
//    {
//     text: (
//       <>
//       Pathways to become an <i>I Am Peacekeeper </i>  Ambassador.
//       </>
//     ),
//     colorClass: "gradient-yellow",
//   },
//   {
//     text: (
//       <>
//       Listing on official <i>I Am Peacekeeper </i> websites.
//       </>
//     ),
//     colorClass: "gradient-blue",
//   },
//    {
//     text: (
//       <>
//       Access to alumni community and advanced courses.
//       </>
//     ),
//     colorClass: "gradient-yellow",
//   },
// ];

const circleCourses = [
  {
    text: (
      <>
        Enrol today.
      </>
    ),
    colorClass: "gradient-blue",
  },
  {
    text: (
      <>
        Join a global community of learners.
      </>
    ),
    colorClass: "gradient-yellow",
  },
   {
    text: (
      <>
      Apply your learning to real‑world change.
      </>
    ),
    colorClass: "gradient-blue",
  },
  {
    text: (
      <>
       Lead the movement for Justice, Love & Peace.
      </>
    ),
    colorClass: "gradient-yellow",
  }
];
const ConclusionCard = ({ text, colorClass }) => (
  <Paper
    elevation={3}
    className={`programCard gradientTrioCards gradientTrioBigCards ${colorClass}`}
    sx={{
      width: 140,
      height: 140,
      borderRadius: "50%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: 2,
      m: "auto",
    }}
  >
    <Typography variant="body2" sx={{ fontFamily: 'var(--primary-font)', fontWeight: 400 }}>{text}</Typography>
  </Paper>
);

const OnlineTestCard = ({ text, colorClass }) => (
  <Paper
    elevation={3}
    className={`programCard gradientTrioCards gradientTrioBigCards  ${colorClass}`}
    sx={{
      width: 140,
      height: 140,
      borderRadius: "50%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: 2,
      m: "auto",
    }}
  >
    <Typography variant="body2" sx={{ fontFamily: 'var(--primary-font)', fontWeight: 400 }}>
      {text}
    </Typography>
  </Paper>
);

const sdgs = [
  {
    title: "SDG 4",
    description: (
      <>
        "Quality Education – <br></br> Infusing human values in <br></br> higher
        education
      </>
    ),

    icon: imgUrl.sdg4Icon,
  },
  {
    title: "SDG 16",
    description: (
      <>
        Peace, Justice & Strong <br></br> Institutions – Nurturing <br></br>{" "}
        conscious student leaders
      </>
    ),
    icon: imgUrl.sdg16Icon,
  },
  {
    title: "SDG 3",
    description: (
      <>
        Good Health & Well-being <br></br> – Emotional and mental <br></br>{" "}
        wellness via values <br></br> training
      </>
    ),
    icon: imgUrl.sdg3Icon,
  },
  {
    title: "SDG 5",
    description: (
      <>
        Gender Equality – <br></br> Promoting inclusion, <br></br> empathy, and
        respect
      </>
    ),
    icon: imgUrl.sdg5Icon,
  },
  {
    title: "SDG 10",
    description: (
      <>
        "Reduced Inequalities <br></br> – Building unity across <br></br>{" "}
        communities and cultures
      </>
    ),
    icon: imgUrl.sdg10Icon,
  },
  {
    title: "SDG 17",
    description: (
      <>
        Partnerships for the <br></br> Goals – International <br></br>{" "}
        collaboration for peace
      </>
    ),
  },
];

const Courses = () => {
  return (
    <>
      {/* InnerPeace Hero Background Section */}
      <Box
        className="programInnerPeaceSectionBg commonBannerBg"
        sx={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "white",
          px: 2,
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 80,
            left: 0,
            display: "flex",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={imgUrl.doveImg}
            alt="Peace Dove Logo"
            sx={{ maxWidth: 200, height: "auto", mr: 1 }}
          />
        </Box>
      </Box>


      {/* InnerPeace Main Section Start */}
      <Box mt={5}>
        <Grid container direction="column" alignItems="center" spacing={2}>
          <Grid
            size={12}
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
          >
            <img src={imgUrl.peaceIcon} className="w-100 peaceImg"></img>
            <Typography variant="h1" className="founder-title mainHeading green-title" sx={{ fontFamily: 'var(--heading-font)', fontWeight: 400 }}>
             I Am Peacekeeper Institute
            </Typography>
            {/* <Typography variant="h5"
          fontWeight="bold"
          gutterBottom
          className="subHeading weathText">
            KNOWLEDGE IS WEALTH
            </Typography> */}
          </Grid>
        </Grid>
      </Box>

      
        {/* <div className="pilotProgrammeinfo">
          <Typography>
            This November 2025 📅 we commence our Pilot Programme.
          </Typography>

          <Typography>
            The first full course is complimentary for everyone ✅.
          </Typography>

          <Typography>

            It’s your opportunity to experience our transformative learning journey at no cost before the regular fee of US $21 🎯 applies in the next term.
          </Typography>

          <Typography>
            On successful completion and assessment, you will receive a Certificate from the I Am Peacekeeper Institute 🛡️.
          </Typography>

          <Typography>
            Please connect with our trainers by email for guidance and enrolment 🤝.
          </Typography>

          <Typography>
            Each course runs Monday to Friday on the dates below, with Zoom access provided for all sessions.
          </Typography>

        </div> */}

        {/* zoom meetings card */}

      <Box
        className="mt-50px"
        sx={{
          textAlign: "start",
          borderRadius: 3,
        }}
        mt={5}

      >
        <Box className="core-values-container zoomMeetings">
          <Container style={{ maxWidth: '100%' }}>
            <Grid container spacing={1} justifyContent="center" sx={{ flexWrap: { xs: 'wrap', md: 'nowrap' } }}>

              <Grid
                size={{ xs: 12, sm: 6, md: 3, lg: 3 }}
                className={`core-card core-card-cardOne`}
              >
                <Box className="core-card-content">
                  {/* <img
                      src={value.image}
                      alt={value.title}
                      className="core-image"
                    /> */}
                  {/* <Typography variant="h6" className="core-title">
                      {value.title}
                    </Typography> */}
                  {/* <Typography variant="body2" className="core-description">
                      {value.description}
                    </Typography> */}

                  <Typography variant="h2" className="founder-title mainHeading green-title">Inner Peace</Typography>
                  <Typography sx={{ fontWeight: 'bold', fontFamily: 'var(--primary-font)' }}>Trainer Neha Bilandani 👩‍🏫</Typography>
                  <Typography sx={{ fontFamily: 'var(--primary-font)' }}> <span>Dates: </span>Mon 3 Nov – Fri 7 Nov 2025 and Mon 10 Nov – Fri 14 Nov 2025 📆</Typography>
                  <Typography sx={{ fontFamily: 'var(--primary-font)' }}><span>Time: </span>
                    3:00 – 3:40 PM IST 🕒
                    Pilot schedule for this cohort (Inner Peace):</Typography>
                  <Typography sx={{ fontFamily: 'var(--primary-font)' }}><span style={{ fontWeight: 'bold' }}>Day 1</span> </Typography>
                  <Typography sx={{ fontFamily: 'var(--primary-font)' }}> Intro and Q&A: Mon 3 Nov 2025</Typography>
                  <Typography sx={{ fontFamily: 'var(--primary-font)' }}><span style={{ fontWeight: 'bold' }}>Days 2–8 </span></Typography>
                  <Typography sx={{ fontFamily: 'var(--primary-font)' }}> Main course: Tue 4 Nov – Fri 7 Nov 2025 and Mon 10 Nov – Wed 12 Nov 2025</Typography>
                  <Typography sx={{ fontFamily: 'var(--primary-font)' }}><span style={{ fontWeight: 'bold' }}>Day 9 </span></Typography>
                  <Typography sx={{ fontFamily: 'var(--primary-font)' }}>  Conclusion: Thu 13 Nov 2025</Typography>
                  <Typography sx={{ fontFamily: 'var(--primary-font)' }}><span style={{ fontWeight: 'bold' }}>Day 10 </span> </Typography>
                  <Typography sx={{ fontFamily: 'var(--primary-font)' }}>  Online test & Certificate: Fri 14 Nov 2025</Typography>
                  
                  <Box sx={{ mt: 3, fontFamily: 'var(--primary-font)', fontWeight: 400 }}>
                    <Typography sx={{ fontFamily: 'var(--primary-font)', mb: 2 }}>
                      Each session cultivates calmness, clarity, and compassion, helping you practise peace in thought, word, and deed 🌱. You will learn through live online classes, thoughtful discussions, and community-based learning, growing at your own pace while standing with a Global Movement 🌍.
                    </Typography>
                    <Typography sx={{ fontFamily: 'var(--primary-font)', mb: 2 }}>
                      Please register by email with your chosen trainer at the earliest 🔔. We look forward to welcoming you and building a generation of conscious, confident, and kind leaders 🔥.
                    </Typography>
                  </Box>

                  {/* <div className="zoomBtndiv">
                    <Button
                      variant="contained"
                      className='zoomLinkbtn'
                      onClick={() =>
                        window.open(
                          'https://i-am-peacekeeper.us11.list-manage.com/track/click?u=29b90def99384b76c623a441b&id=449464b01e&e=9a7d6d37b2',
                          '_blank',
                          'noopener,noreferrer'
                        )
                      }
                    >
                      Zoom Link
                    </Button>
                  </div> */}

                  <Link
                    sx={{ marginTop: '20px', color: '#beac00' }}
                    href="mailto:neha@i-ampeacekeeper.com"
                    color="inherit"
                    className="trainerEmails"
                    fontFamily="var(--default-font)"
                  >
                    <span>Email: </span> neha@i-ampeacekeeper.com
                  </Link>

                </Box>
              </Grid>

              <Grid
                size={{ xs: 12, sm: 6, md: 3, lg: 3 }}
                className={`core-card core-card-cardTwo`}
              >
                <Box className="core-card-content">
                  {/* <img
                      src={value.image}
                      alt={value.title}
                      className="core-image"
                    /> */}
                  {/* <Typography variant="h6" className="core-title">
                      {value.title}
                    </Typography> */}
                  {/* <Typography variant="body2" className="core-description">
                      {value.description}
                    </Typography> */}

                  <Typography variant="h2" className="founder-title mainHeading green-title">Peace Leadership</Typography>
                  <Typography sx={{ fontWeight: 'bold' }}>Trainer Narges Jalali & Trainer Bidisha Banerjee 👩‍🏫</Typography>
                  <Typography> <span>Dates: </span>Mon 3 Nov – Fri 7 Nov 2025 and Mon 10 Nov – Fri 14 Nov 2025 📆</Typography>
                  <Typography><span>Time: </span>
                    4:00 – 4:40 PM IST 🕓
                    Pilot schedule for this cohort (Peace Leadership):</Typography>
                  <Typography><span style={{ fontWeight: 'bold' }}>Day 1</span> </Typography>
                  <Typography>Intro and Q&A: Mon 3 Nov 2025</Typography>
                  <Typography><span style={{ fontWeight: 'bold' }}>Days 2–8 </span></Typography>
                  <Typography> Main course: Tue 4 Nov – Fri 7 Nov 2025 and Mon 10 Nov – Wed 12 Nov 2025</Typography>
                  <Typography><span style={{ fontWeight: 'bold' }}>Day 9 </span></Typography>
                  <Typography> Conclusion: Thu 13 Nov 2025</Typography>
                  <Typography><span style={{ fontWeight: 'bold' }}>Day 10 </span> </Typography>
                  <Typography>Online test & Certificate: Fri 14 Nov 2025</Typography>

                  {/* <div className="zoomBtndiv">
                    <Button
                      variant="contained"
                      className='zoomLinkbtn'
                      onClick={() =>
                        window.open(
                          'https://i-am-peacekeeper.us11.list-manage.com/track/click?u=29b90def99384b76c623a441b&id=97947c31b4&e=9a7d6d37b2',
                          '_blank',
                          'noopener,noreferrer'
                        )
                      }
                    >
                      Zoom Link
                    </Button>
                  </div> */}

                  <Link
                    sx={{ marginTop: '20px', color: '#beac00' }}
                    href="mailto:narges@i-am-peacekeeper.com"
                    color="inherit"
                    className="trainerEmails"
                    fontFamily={"var(--default-font)"}
                  >
                    <span>Emails: </span> narges@i-am-peacekeeper.com
                  </Link>

                  <Link
                    sx={{ color: '#beac00' }}
                    href="mailto:bidisha@i-am-peacekeeper.com"
                    color="inherit"
                    className="trainerEmails"
                    fontFamily={"var(--default-font)"}
                  >
                    bidisha@i-am-peacekeeper.com
                  </Link>


                </Box>
              </Grid>

              <Grid
                size={{ xs: 12, sm: 6, md: 3, lg: 3 }}
                className={`core-card core-card-cardOne`}
              >
                <Box className="core-card-content">
                  {/* <img
                      src={value.image}
                      alt={value.title}
                      className="core-image"
                    /> */}
                  {/* <Typography variant="h6" className="core-title">
                      {value.title}
                    </Typography> */}
                  {/* <Typography variant="body2" className="core-description">
                      {value.description}
                    </Typography> */}

                  <Typography variant="h2" className="founder-title mainHeading green-title">Women for Peace</Typography>
                  <Typography sx={{ fontWeight: 'bold' }}>Trainer Katalin Enekes</Typography>
                   <Typography> <span>Dates: </span>Mon 1 Dec – Fri 5 Dec 2025 and Mon 8 Dec – Fri 12 Dec 2025 📅</Typography>
                  <Typography><span>Time: </span>
                   4:00 – 4:40 PM IST 🕓
                   Pilot schedule for this cohort (Women for Peace):</Typography>
                  <Typography><span style={{ fontWeight: 'bold' }}>Day 1</span> </Typography>
                  <Typography>Intro and Q&A: Mon 1 Dec 2025</Typography>
                  <Typography><span style={{ fontWeight: 'bold' }}>Days 2–8 </span></Typography>
                  <Typography> Main course: Tue 2 Dec – Fri 5 Dec 2025 and Mon 8 Dec – Wed 10 Dec 2025</Typography>
                  <Typography><span style={{ fontWeight: 'bold' }}>Day 9 </span></Typography>
                  <Typography> Conclusion: Thu 11 Dec 2025</Typography>
                  <Typography><span style={{ fontWeight: 'bold' }}>Day 10 </span> </Typography>
                  <Typography>Online test & Certificate: Fri 12 Dec 2025</Typography>

                  {/* <div className="zoomBtndiv">
                    <Button
                      variant="contained"
                      className='zoomLinkbtn'
                      onClick={() =>
                        window.open(
                          'https://us06web.zoom.us/j/82789825413?pwd=4nbrqDDh0j4ELv99sV2yA5bHW30oaz.1',
                          '_blank',
                          'noopener,noreferrer'
                        )
                      }
                    >
                      Zoom Link
                    </Button>
                  </div> */}


                  <Link
                    sx={{ color: '#beac00' }}
                    href="mailto:katalin@i-am-peacekeeper.com"
                    color="inherit"
                    className="trainerEmails"
                    fontFamily="var(--default-font)"
                  >
                    <span>Email: </span> katalin@i-am-peacekeeper.com
                  </Link>

                </Box>
              </Grid>

              <Grid
                size={{ xs: 12, sm: 6, md: 3, lg: 3 }}
                className={`core-card core-card-cardTwo`}
              >
                <Box className="core-card-content">
                  <Typography variant="h2" className="founder-title mainHeading green-title">Global Peace Meditation</Typography>
                  <Typography sx={{ fontWeight: 'bold' }}>Trainer Zarina Aziz</Typography>
                  <Typography><span>Date: </span>Friday, 2 January 2026 📅</Typography>
                  <Typography><span>Time: </span>3:30 – 4:10 PM IST ⏱️</Typography>
                  <Typography sx={{ mt: 1 }}>
                    <span style={{ fontWeight: 'bold' }}>Live, One Day Global Session (Global Peace Meditation)</span>
                  </Typography>
                  <Typography>
                    <span style={{ fontWeight: 'bold' }}>Single Session</span>
                  </Typography>
                  <Typography>
                    Guided collective stillness, grounding and closing reflection
                  </Typography>
                  <Typography sx={{ mt: 1 }}>
                    <span style={{ fontWeight: 'bold' }}>Format</span>
                  </Typography>
                  <Typography>
                    Live online session + Replay access
                  </Typography>
                  <Link
                    sx={{ marginTop: '20px', color: '#beac00', display: 'block' }}
                    href="mailto:meditate@i-am-peacekeeper.com"
                    color="inherit"
                    className="trainerEmails"
                    fontFamily="var(--default-font)"
                  >
                    <span>Email: </span> meditate@i-am-peacekeeper.com
                  </Link>
                  <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center' }}>
                    <Button
                      variant="contained"
                      onClick={() => window.open('https://www.youtube.com/live/hnhp-Z-a4_8?si=IO7uu6ddGiryM33V', '_blank', 'noopener,noreferrer')}
                      sx={{
                        background: 'linear-gradient(180deg, #4b77b1, #005498)',
                        border: '5px solid #d7d7d8',
                        fontWeight: 700,
                        padding: '12px 20px',
                        borderRadius: '50px',
                        width: '200px',
                        color: '#fff',
                        textTransform: 'none',
                         fontFamily: 'var(--default-font)',
                        fontSize: '1rem',
                        '&:hover': {
                          background: 'linear-gradient(180deg, #3d5f8f, #004377)',
                        }
                      }}
                    >
                      YouTube Live
                    </Button>
                  </Box>
                </Box>
              </Grid>

            </Grid>
          </Container>
        </Box>
      </Box>

      <div className="sessionText">
        <Typography>
          Each session cultivates calmness, clarity and compassion, helping you practise peace in thought, word and deed 🌱. You’ll learn through live online classes, thoughtful discussion and community-based learning, growing at your pace while standing with a Global Movement 🌍.
        </Typography>

        <Typography>
          Please register by email with your chosen trainer at the earliest 🔔. We look forward to welcoming you and building a generation of conscious, confident and kind leaders 🔥.
        </Typography>


      </div>

      <div className="d-none">
      <Box>
         {/* GLOBAL PEACE MEDITATION Header */}
         {/* <Box
           sx={{
             background: 'linear-gradient(90deg, #045b93, #3e6a73)',
             borderRadius: { xs: '8px', sm: '12px' },
             py: { xs: 1, sm: 1.5, md: 2 },
             px: { xs: 1, sm: 2, md: 3 },
             textAlign: 'center',
             maxWidth: { xs: '100%', sm: '400px', md: '400px' },
             mx: 'auto',
             mb: { xs: 2, sm: 0, md: 0 },
             mt: { xs: 3, sm: 4 },
             
           }}
           className="d-none"
         >
           <Typography
             sx={{
               color: "#fff",
               fontSize: { xs: '18px', sm: '20px', md: '20px', lg: '22px' },
               fontWeight: 700,
               textTransform: 'uppercase',
               letterSpacing: { xs: '0.05em', sm: '0.1em' },
               fontFamily: 'var(--default-font)'
             }}
           >
             GLOBAL PEACE MEDITATION
           </Typography>
         </Box> */}

         {/* Top Row: DATES, Trainer, TIME */}
         <Grid 
           container 
           spacing={{ xs: 2, sm: 2, md: 1, lg: 1, xl: 1 }} 
           justifyContent="center" 
           mt={{ xs: 4, sm: 0 }}
           mb={4} 
           className="iapmInstitute"
           sx={{
             maxWidth: { md: '900px', lg: '1000px', xl: '1100px' },
             mx: 'auto',
             px: { xs: 2, sm: 2, md: 1, lg: 1 }
           }}
         >
           {/* DATES Circle - Left */}
           <Grid size={{ xs: 12, sm: 4, md: 4 }} 
              sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column'
              }}>
            <Typography
              fontWeight="bold"
              sx={{
                fontSize: '18px',
                textTransform: "uppercase", 
                color: "#000", 
                borderTop: "2px solid #000",
                borderBottom: "2px solid #000",
                display: "inline-block",
                width: '120px',
                textAlign: 'center',
                mb: 2
              }}
            >
              DATE
            </Typography>
             <Card 
             sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '16px',
              height:180,
              width:180,
              marginTop: '20px',
              borderRadius: "50%",
              background: 'linear-gradient(90deg, #37c1d6, #3e6a73)'
            }}>
              <CardContent sx={{ textAlign: 'center', p: 0 }}>
                <Box
                  sx={{
                    display: 'inline-flex',
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                    mb: 1
                  }}
                >
                  <Typography
                    sx={{
                      color: "#fff",
                      fontSize: '28px',
                      fontWeight: 'bold',
                      lineHeight: 1,
                      display: 'inline'
                    }}
                  >
                    2
                  </Typography>
                  <Typography
                    component="span"
                    sx={{
                      textTransform: "uppercase",
                      color: "#fff",
                      fontSize: '14px',
                      fontWeight: 'bold',
                      lineHeight: 1,
                      verticalAlign: 'top',
                      ml: 0.25,
                      position: 'relative',
                      top: '-4px'
                    }}
                  >
                    ND
                  </Typography>
                </Box>
                <Typography
                  sx={{
                    textTransform: "uppercase",
                    color: "#fff",
                    fontSize: '18px',
                    mb: 1
                  }}
                >
                  JANUARY
                </Typography>
                <Typography
                  sx={{
                    textTransform: "uppercase",
                    color: "#fff",
                    fontSize: '18px',
                    borderTop: '1px solid #fff',
                    borderBottom: '1px solid #fff',
                    display: 'inline-block',
                    py: 0.5,
                    mb: 1
                  }}
                >
                  2026
                </Typography>
                <Typography
                  sx={{
                    textTransform: "uppercase",
                    color: "#fff",
                    fontSize: '14px',
                    mt: 1
                  }}
                >
                  FRIDAY
                </Typography>
              </CardContent>
             </Card>
           </Grid>

           {/* Trainer Circle - Middle */}
           <Grid size={{ xs: 12, sm: 4, md: 4 }} 
              sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column'
              }}>
            <Card 
             sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '16px',
              height:180,
              width:180,
              mt: { xs: '20px', sm: '69px' },
              borderRadius: "50%",
              background: 'linear-gradient(90deg, #37c1d6, #3e6a73)'
            }}>
              <CardContent sx={{ textAlign: 'center', p: 0 }}>
                <Typography
                  sx={{
                    textTransform: "uppercase",
                    color: "#fff",
                    fontSize: '16px',
                    mb: 1
                  }}
                >
                  Trainer
                </Typography>
                <Typography
                  sx={{
                    color: "#fff",
                    fontSize: '20px',
                    fontWeight: 'bold',
                    mb: 0.5
                  }}
                >
                  Zarina Aziz
                </Typography>
              </CardContent>
             </Card>
           </Grid>

           {/* TIME Circle - Right */}
           <Grid size={{ xs: 12, sm: 4, md: 4 }} 
              sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column'
              }}>
            <Typography
              fontWeight="bold"
              sx={{
                fontSize: '18px',
                textTransform: "uppercase", 
                color: "#000", 
                borderTop: "2px solid #000",
                borderBottom: "2px solid #000",
                display: "inline-block",
                width: '120px',
                textAlign: 'center',
                mb: 2
              }}
            >
              TIME
            </Typography>
             <Card 
             sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '16px',
              height:180,
              width:180,
              marginTop: '20px',
              borderRadius: "50%",
              background: 'linear-gradient(90deg, #37c1d6, #3e6a73)'
            }}>
              <CardContent sx={{ textAlign: 'center', p: 0, position: 'relative' }}>
                <Box
                  sx={{
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '15px',
                    mb: 1
                  }}
                >
                  {/* LEFT TIME - 3:30 PM */}
                  <Typography
                    sx={{
                      fontWeight: 'bold',
                      fontSize: '20px',
                      textAlign: 'right',
                      lineHeight: 1.1,
                      marginBottom: '20px',
                      color: "#fff"
                    }}
                  >
                    3:30<br />PM
                  </Typography>

                  {/* DIAGONAL DIVIDER */}
                  <Box
                    sx={{
                      width: '1px',
                      height: '75px',
                      backgroundColor: '#fff',
                      transform: 'rotate(25deg)',
                    }}
                  />

                  {/* RIGHT TIME - 4:10 PM */}
                  <Typography
                    sx={{
                      fontWeight: 'bold',
                      marginTop: '20px',
                      fontSize: '20px',
                      textAlign: 'left',
                      lineHeight: 1.1,
                      color: "#fff"
                    }}
                  >
                    4:10<br />PM
                  </Typography>
                </Box>

                {/* IST below */}
                <Typography
                  sx={{
                    marginTop: '10px',
                    borderTop: '1px solid #fff',
                    display: 'inline-block',
                    width: '100px',
                    fontWeight: 'bold',
                    fontSize: '16px',
                    color: "#fff",
                    pt: 0.5
                  }}
                >
                  IST
                </Typography>
              </CardContent>
             </Card>
           </Grid>
         </Grid>

         {/* Email Address - Centered */}
         <Box sx={{ textAlign: 'center', mt: 4, mb: 3 }}>
           <Link
             sx={{
               color: '#beac00',
               textDecoration: 'underline',
               fontSize: { xs: '16px', sm: '18px' },
               fontWeight: 600
             }}
             href="mailto:meditate@i-am-peacekeeper.com"
             color="inherit"
             underline="hover"
           >
             meditate@i-am-peacekeeper.com
           </Link>
         </Box>

         {/* Event Title Bar */}
         <Box
           sx={{
             backgroundColor: '#72ace3',
             borderRadius: '12px',
             py: 1,
             px: 4,
             textAlign: 'center',
             maxWidth: '800px',
             mx: 'auto',
             mb: 4
           }}
         >
           <Typography
             sx={{
               color: "#2c2e35",
               fontSize: { xs: '18px', sm: '20px', md: '20px' },
               fontWeight: 600,
               textTransform: 'none',
               fontFamily: 'var(--default-font)'
             }}
           >
             A Collective Moment of Stillness
           </Typography>
         </Box>

         {/* Benefits List */}
         <Box
           sx={{
             maxWidth: '600px',
             mx: 'auto',
             mb: 4
           }}
         >
           <Typography
             sx={{
               color: "#2c2e35",
               fontWeight: 600,
               fontSize: { xs: '16px', sm: '18px' },
               textAlign: 'center',
               borderBottom: '1px solid rgba(44, 46, 53, 0.3)',
               pb: 1.5,
               mb: 1.5,
               fontFamily: 'var(--default-font)'
             }}
           >
             Participation Certificate
           </Typography>
           <Typography
             sx={{
               color: "#2c2e35",
               fontWeight: 600,
               fontSize: { xs: '16px', sm: '18px' },
               textAlign: 'center',
               borderBottom: '1px solid rgba(44, 46, 53, 0.3)',
               pb: 1.5,
               mb: 1.5,
               fontFamily: 'var(--default-font)'
             }}
           >
             Replay Access
           </Typography>
           <Typography
             sx={{
               color: "#2c2e35",
               fontWeight: 600,
               fontSize: { xs: '16px', sm: '18px' },
               textAlign: 'center',
               borderBottom: '1px solid rgba(44, 46, 53, 0.3)',
               pb: 1.5,
               mb: 1.5,
               fontFamily: 'var(--default-font)'
             }}
           >
             7 Day Inner Rest Guide
           </Typography>
           <Typography
             sx={{
               color: "#2c2e35",
               fontWeight: 600,
               fontSize: { xs: '16px', sm: '18px' },
               textAlign: 'center',
               fontFamily: 'var(--default-font)'
             }}
           >
             5 Minute Grounding Audio
           </Typography>
         </Box>
      </Box>

      <Box sx={{ display: 'none' }}>
         <Grid container spacing={0} justifyContent="center" mt={4} mb={4} className="iapmInstitute secondRowcircles" sx={{ display: 'none' }}>
           <Grid size={{ xs: 12, sm: 4, md: 4 , lg:4 }} 
              sx=
              {{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column'
              }} justifyContent="center">
            <Typography
              fontWeight="bold"
              sx=
              {{
                fontSize: '18px',
                textTransform: "uppercase", 
                color: "#000", 
                borderTop: "2px solid #000",
                borderBottom: "2px solid #000",
                display: "inline-block",
                width: '200px',
                textAlign: 'center'
              }}
            >
              Inner <br /> Peace
            </Typography>
             <Card 
             sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '16px',
              height:180,
              width:180 ,
              marginTop: '20px',
              borderRadius: "50%",
              background: 'linear-gradient(90deg, #37c1d6, #3e6a73)'}}>
              <CardContent
                sx={{
                  color: '#fff',
                  textAlign: 'center',
                  position: 'relative',
                  padding: 0,
                  paddingBottom: 0
                }}
              >
                <Box
                  sx={{
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '15px', // distance between two times
                  }}
                >
                  {/* LEFT TIME */}
                  <Typography
                    sx={{
                      fontWeight: 'bold',
                      fontSize: '20px',
                      textAlign: 'right',
                      lineHeight: 1.1,
                      marginBottom: '20px'
                    }}
                  >
                    3:00<br />PM
                  </Typography>

                  {/* SLANTED DIVIDER */}
                  <Box
                    sx={{
                      width: '1px',
                      height: '75px',
                      backgroundColor: '#fff',
                      transform: 'rotate(25deg)',
                    }}
                  />

                  {/* RIGHT TIME */}
                  <Typography
                    sx={{
                      fontWeight: 'bold',
                      marginTop: '20px',
                      fontSize: '20px',
                      textAlign: 'left',
                      lineHeight: 1.1,
                    }}
                  >
                    3:40<br />PM
                  </Typography>
                </Box>

                {/* IST below */}
                <Typography
                  sx={{
                    marginTop: '10px',
                    borderTop: '1px solid #fff',
                    display: 'inline-block',
                    width: '125px',
                    fontWeight: 'bold',
                    fontSize: '16px',
                  }}
                >
                  IST
                </Typography>
              </CardContent>
             </Card>
             <div class="triangle"></div>

             <div className="trainerDetailsmobile">
                <Typography
              fontWeight="bold"
              sx=
              {{
                fontSize: '18px',
                textTransform: "uppercase", 
                color: "#000", 
                display: "inline-block",
                width: '200px',
                textAlign: 'center'
              }}
            >
              Trainer
            </Typography>
            <Typography
              fontWeight="bold"
              sx=
              {{
                fontSize: '18px',
                color: "#000", 
                display: "inline-block",
                width: '200px',
                textAlign: 'center'
              }}
            >
              Neha Bilandani 
            </Typography>

            <Link
              sx={{marginTop: '20px' , color: '#beac00' ,  textDecoration: 'underline'}}
              href="mailto:neha@i-ampeacekeeper.com"
              color="inherit"
              underline="hover"
            >
              neha@i-ampeacekeeper.com
            </Link>
             </div>
           </Grid>

           <Grid size={{ xs: 12, sm: 4, md: 4, lg:4  }} 
              sx=
              {{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column'
              }} justifyContent="center">
            <Typography
              fontWeight="bold"
              sx=
              {{
                fontSize: '18px',
                textTransform: "uppercase", 
                color: "#000", 
                borderTop: "2px solid #000",
                borderBottom: "2px solid #000",
                display: "inline-block",
                width: '200px',
                textAlign: 'center'
              }}
            >
              PEACE <br/> LEADERSHIP
            </Typography>
             <Card 
             sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '16px',
              height:180,
              width:180 ,
              marginTop: '20px',
              borderRadius: "50%",
              background: 'linear-gradient(90deg, #37c1d6, #3e6a73)'}}>
              <CardContent
                sx={{
                  color: '#fff',
                  textAlign: 'center',
                  position: 'relative',
                  padding: 0,
                  paddingBottom: 0
                }}
              >
                <Box
                  sx={{
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '15px', // distance between two times
                  }}
                >
                  {/* LEFT TIME */}
                  <Typography
                    sx={{
                      fontWeight: 'bold',
                      fontSize: '20px',
                      textAlign: 'right',
                      lineHeight: 1.1,
                      marginBottom: '20px'
                    }}
                  >
                    4:00<br />PM
                  </Typography>

                  {/* SLANTED DIVIDER */}
                  <Box
                    sx={{
                      width: '1px',
                      height: '75px',
                      backgroundColor: '#fff',
                      transform: 'rotate(25deg)',
                    }}
                  />

                  {/* RIGHT TIME */}
                  <Typography
                    sx={{
                      fontWeight: 'bold',
                      marginTop: '20px',
                      fontSize: '20px',
                      textAlign: 'left',
                      lineHeight: 1.1,
                    }}
                  >
                    4:40<br />PM
                  </Typography>
                </Box>

                {/* IST below */}
                <Typography
                  sx={{
                    marginTop: '10px',
                    borderTop: '1px solid #fff',
                    display: 'inline-block',
                    width: '125px',
                    fontWeight: 'bold',
                    fontSize: '16px',
                  }}
                >
                  IST
                </Typography>
              </CardContent>
             </Card>
             <div class="triangle"></div>

             <div className="trainerDetailsmobile">
              <Typography
              fontWeight="bold"
              sx=
              {{
                fontSize: '18px',
                textTransform: "uppercase", 
                color: "#000",
                display: "inline-block",
                width: '200px',
                textAlign: 'center'
              }}
            >
              Trainer
            </Typography>

            <Typography
              fontWeight="bold"
              sx=
              {{
                fontSize: '18px',
                color: "#000", 
                display: "inline-block",
                width: '200px',
                textAlign: 'center'
              }}
            >
              Narges Jalali
            </Typography>

            <Link
              sx={{marginTop: '20px' , color: '#beac00' ,  textDecoration: 'underline'}}
              href="mailto:narges@i-am-peacekeeper.com"
              color="inherit"
              underline="hover"
            >
              narges@i-am-peacekeeper.com
            </Link>

            <Typography
              fontWeight="bold"
              sx=
              {{
                fontSize: '18px',
                textTransform: "uppercase", 
                color: "#000",
                display: "inline-block",
                width: '200px',
                textAlign: 'center',
                marginTop: '10px'
              }}
            >
              Trainer
            </Typography>

            <Typography
              fontWeight="bold"
              sx=
              {{
                fontSize: '18px',
                color: "#000", 
                display: "inline-block",
                width: '200px',
                textAlign: 'center'
              }}
            >
              Bidisha Banerjee
            </Typography>

            <Link
              sx={{marginTop: '20px' , color: '#beac00' ,  textDecoration: 'underline'}}
              href="mailto:bidisha@i-am-peacekeeper.com"
              color="inherit"
              underline="hover"
            >
              bidisha@i-am-peacekeeper.com
            </Link>
             </div>
           </Grid>

           <Grid size={{ xs: 12, sm: 4, md: 4, lg:4  }} 
              sx=
              {{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column'
              }} justifyContent="center">
            <Typography
              fontWeight="bold"
              sx=
              {{
                fontSize: '18px',
                textTransform: "uppercase", 
                color: "#000", 
                borderTop: "2px solid #000",
                borderBottom: "2px solid #000",
                display: "inline-block",
                width: '200px',
                textAlign: 'center'
              }}
            >
              WOMEN <br />FOR PEACE
            </Typography>
             <Card 
             sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '16px',
              height:180,
              width:180 ,
              marginTop: '20px',
              borderRadius: "50%",
              background: 'linear-gradient(90deg, #37c1d6, #3e6a73)'}}>
              <CardContent>
              <Typography
              variant="subtitle1"
              // fontWeight="bold"
              sx=
              {{ textTransform: "uppercase",
                color: "#fff",
                textAlign: 'center'
              }}
            >
                  LAUNCH
                  ON DEC 1st
                  2025
            </Typography>

              </CardContent>
             </Card>
             <div class="triangle"></div>

             <div className="trainerDetailsmobile">
              <Typography
              fontWeight="bold"
              sx=
              {{
                fontSize: '18px',
                textTransform: "uppercase", 
                color: "#000",
                display: "inline-block",
                width: '200px',
                textAlign: 'center'
              }}
            >
              Trainer
            </Typography>

            <Typography
              fontWeight="bold"
              sx=
              {{
                fontSize: '18px',
                color: "#000", 
                display: "inline-block",
                width: '200px',
                textAlign: 'center'
              }}
            >
              Katalin Enekes
            </Typography>
            <Link
              sx={{marginTop: '20px' , color: '#beac00' ,  textDecoration: 'underline'}}
              href="mailto:katalin@i-am-peacekeeper.com"
              color="inherit"
              underline="hover"
            >
              katalin@i-am-peacekeeper.com
            </Link>
             </div>
           </Grid>

         </Grid>
      </Box>
      
      </div>

      {/* <Box
        sx={{
          textAlign: "center",
          borderRadius: 3,
        }}
        mt={5}
        className="core-values-container"
      >
      

        <Container className="core-values-container">
          <Grid container spacing={1} justifyContent="center">
            {coreValues.map((value, index) => (
              <Grid  key={index}
                  size={{ xs: 12, md: 3, sm: 6 }}
                  className={`core-card core-card-${index % 4}`}>
                 <Box className="core-card-content">
      
                    <Typography variant="body2" className="core-description">
                      {value.description}
                    </Typography>
                  </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box> */}
     
      {/* course portfolio */}
      <Box
        sx={{
          textAlign: "center",
          borderRadius: 3,
        }}
        mt={5}
        className="TabPaddingContainer"
      >

        {/* Title */}
        <Typography
          variant="h2"
          fontWeight={400}
          gutterBottom
          className="subHeading"
          sx={{ fontFamily: 'var(--heading-font)' }}
        >
        Course portfolio
        </Typography>

        <Container className="paddingContainer mt-50px max-width-800px">
          <Grid container spacing={5} justifyContent="center" mb={4}>
            {onlineTest.map(({ text, colorClass }, index) => (
              <Grid size={{ xs: 12, sm: 3, md: 3 }} key={index}>
                <OnlineTestCard text={text} colorClass={colorClass} />
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
     
      {/* Sub‑programmes  */}
      <Box
        className="mt-50px"
        sx={{
          textAlign: "center",
          borderRadius: 3,
        }}
        mt={5}
        
      >

         {/* Title */}
        <Typography
          variant="h2"
          fontWeight={400}
          gutterBottom
          className="subHeading"
          sx={{ fontFamily: 'var(--default-font)' }}
        >
        Sub Programmes
        </Typography>
        <Box className="core-values-container">
          <Container>
            <Grid container spacing={1} justifyContent="center">
              {coreValues.map((value, index) => (
                <Grid
                  key={index}
                  size={{ xs: 12, md: 3, sm: 6 }}
                  className={`core-card core-card-${index % 4}`}
                >
                  <Box className="core-card-content">
                    <Typography variant="body2" className="core-description" sx={{ fontFamily: 'var(--primary-font)', fontWeight: 400 }}>
                      {value.description}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Container>
        </Box>
      </Box>

      {/* benefits all courses */}

       <Box
        sx={{
          textAlign: "center",
          borderRadius: 3,
        }}
        mt={0}
        className="core-values-container"
      >
       {/* Title */}
        <Typography
          variant="h2"
          fontWeight={400}
          gutterBottom
          className="subHeading"
          sx={{ fontFamily: 'var(--heading-font)' }}
        >
        Benefits 
        </Typography>
       <Container className="core-values-container">
          <Grid container spacing={1} justifyContent="center">
            {courseBenefits.map((value, index) => (
              <Grid  key={index}
                  size={{ xs: 12, md: 3, sm: 6 }}
                  className={`core-card core-card-${index % 4}`}>
                 <Box className="core-card-content">
      
                    <Typography variant="body2" className="core-description" sx={{ fontFamily: 'var(--primary-font)', fontWeight: 400 }}>
                      {value.description}
                    </Typography>
                  </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
     
       {/* benefits all courses */}

       <Box
        sx={{
          textAlign: "center",
          borderRadius: 3,
          marginBottom:'70px'
        }}
        mt={0}
        className="TabPaddingContainer"

      >
       {/* Title */}
        <Typography
          variant="h2"
          fontWeight={400}
          gutterBottom
          className="subHeading"
          sx={{ fontFamily: 'var(--heading-font)' }}
        >
        The Journey Continues
        </Typography>
       <Container className="paddingContainer mt-50px" mb={5}>
          <Grid container spacing={5} justifyContent="center" mb={4}>
            {circleCourses.map(({ text, colorClass }, index) => (
              <Grid size={{ xs: 12, sm: 3, md: 2 }} key={index}>
                <ConclusionCard text={text} colorClass={colorClass} />
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
      {/* Blue Button */}
      {/* <Box className="d-flex-align-center-justify-center" mt={5}>
        <Grid container spacing={0}>
          <Grid size={12}>
            <Button variant="contained" className="blueButton">
              (400 Minutes Total)
            </Button>
          </Grid>
        </Grid>
      </Box> */}

      {/* last contact section */}

      {/* <Box
        sx={{ textAlign: "center", py: 4 }}
        className="contactQueryMainSection"
      >
        <Typography
          variant="subtitle1"
          fontWeight="bold"
          gutterBottom
          className="contactQueryTitle"
        >
          For queries and support, please contact:
        </Typography>

        <Stack
          direction="row"
          spacing={2}
          justifyContent="center"
          alignItems="center"
          divider={<Divider orientation="vertical" flexItem />}
        >
          <Typography variant="body1">Ms. Neha Bilandani</Typography>
          <Typography variant="body1">
            <a
              href="mailto:neha@i-am-peacekeeper.com"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              neha@i-am-peacekeeper.com
            </a>
          </Typography>
          <Typography variant="body1">+91 99306 80975</Typography>
        </Stack>
      </Box> */}
    </>
  );
};

export default Courses;
